<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-practice.svg" can-back-flag="1" isPracticeDetail="true"></Header>
    </header>

    <div id="wrapper">
      <div class="content">
        <div class="answer-list">
          <section v-for='row in answerList'>
            <h3 class="ttl">{{ row.part }}{{ row.chapter }}　問{{ row.question_num }}</h3>
            <div class="inner-box">
              <div class="practice-qbox">
                <h4 class="answer-box">{{ row.answer_title }}</h4>
                <div class="txt-box qno" :class="{'exp': row.answer_title == '解答例'}" v-html="row.answer"></div>
              </div>
              <div class="practice-answer">
                <h4 class="ansttl">解説</h4>
                <div v-html="row.expl"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-practice")
    $("body").addClass("page-practice-answer")
    cmd.adjustStyle()

    if ( this.answerList.length == 0 ) {
      this.returnToIndex()
    }
  },
  methods: {
    ...mapActions('PracticeModule', {
      'prevAction': 'prevAction',
      'returnToIndex': 'returnToIndex',
    }),
  },
  computed: {
    ...mapGetters('PracticeModule', {
      'answerList': 'getAnswerList',
    }),
  },
  components: {
    Header
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PracticeAnswerList.vue